import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyTravelList = loadable(() => import(/* webpackChunkName: "content/guest/widgets/travelList" */ './TravelList'), 'TravelList');
